module.exports = __webpack_public_path__ + "assets/img/i4.eb54e2c2.png";